import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import * as ReactDOM from 'react-dom/client';

import { Toaster } from '@app-evolution-cms/element-ui';

import { config } from './config';
import Routes from './modules/routes';

import '@fontsource-variable/inter/index.css';
import './styles.css';

// Initialize monaco editor loader
import { loader } from '@monaco-editor/react';
loader.init();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: Infinity,
    },
  },
});

const { IS_DEV_ENV } = config();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <QueryClientProvider client={queryClient}>
    <Routes />
    <Toaster duration={3000} position="top-right" />
    {IS_DEV_ENV ? <ReactQueryDevtools /> : null}
  </QueryClientProvider>,
);
